import React from 'react';
import { Box, ListItem } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight, faCircle, faCircleCheck } from '@fortawesome/pro-regular-svg-icons';

interface IStatusIconProps {
  children: React.ReactNode;
  isActive?: boolean;
  isComplete?: boolean;
}

export const CASTrackerItem: React.FC<IStatusIconProps> = (props: IStatusIconProps) => {
  const { children, isActive, isComplete } = props;

  const getProps = () => {
    if (isActive) {
      return { suffix: ' (Active)', color: 'active', icon: faChevronCircleRight };
    }
    if (isComplete) {
      return { suffix: ' (Complete)', color: 'success', icon: faCircleCheck };
    }
    return { suffix: null, color: 'extra-muted', icon: faCircle };
  };

  const { suffix, color, icon } = getProps();

  return (
    <ListItem display="flex" mb={4} lineHeight={5} ml={0}>
      <Box as="span" color={color} mr={2}>
        <FontAwesomeIcon icon={icon} size="lg" fixedWidth />
      </Box>

      {children}

      {suffix}
    </ListItem>
  );
};
